import {tenantSchedulerBaseRoute} from '../baseRoute';
import {isRafiDeviceStockAssetGroup} from '../../routeHelper';
import {ASSET_GROUP_DEFINITION} from '../../../../../../components/updatejobs/consts';
import {ContextInfoProps, RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import Icon from '../../../../../../assets/icon-updatejobs.svg?react';

export default {
	...tenantSchedulerBaseRoute,
	relativePath: 'inventoryschedule',
	iconSvg: Icon,
	config: {
		onlyWithAssetGroupDefinition: ASSET_GROUP_DEFINITION.INVENTORY
	},
	show: (context: ContextInfoProps['contextInfo'] | null | undefined) => !isRafiDeviceStockAssetGroup(context)
} satisfies RouteConfig;
